import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '../../../public/c.svg'


const _hoisted_1 = {
  key: 0,
  class: /*#__PURE__*/_normalizeClass(['-mb-5px'])
}
const _hoisted_2 = {
  key: 0,
  class: "transform scale-125 ml-1.5 my-0",
  src: _imports_0
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.icons?.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.isRawIcon)
          ? (_openBlock(), _createElementBlock("img", _hoisted_2))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.parsedIcons, (icon, index) => {
              return (_openBlock(), _createElementBlock("span", {
                style: _normalizeStyle('font-size:' + _ctx.fontSize),
                class: _normalizeClass([
				_ctx.classExceptions[icon] ?? '',
				'mt-0.5 mx-auto',
				_ctx.useTwoTone ? 'material-icons-two-tone' : 'material-icons-outlined',
			]),
                key: _ctx.id + '-icon-' + index
              }, _toDisplayString(icon), 7))
            }), 128))
      ]))
    : _createCommentVNode("", true)
}